import React, { useState } from "react";
import images from "../../../../Utils/importImages";
import {
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import ResetPassword from "./ResetPassword";
import { sendOtp, VerifyOTP } from "../../../../Redux/Apis/User-Apis";
import { useSelector } from "react-redux";

function ResetPasswordVerify({
  setOpenResetPassword,
  credential,
  credentialType,
}) {
  const [inputText, setInputText] = useState("");
  const [textError, setTextError] = useState("");
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [timer, setTimer] = useState(60); // Initial timer for 60 seconds

  // The actually-selected region/pipeline (set by the region dropdown in Header.jsx) — must be
  // sent with the OTP verify call instead of a hardcoded pipeline.
  const selectedPipelineId = useSelector((state) => state.user.selectedPipelineId);

  const onChangeInput = (e) => {
    setInputText(e.target.value);
  };

  let [openResetPasswordPop, setOpenResetPasswordPop] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async () => {
    let structure = {
      identifier: credential,
      otp: inputText,
      type: "--",
      pipeline_id: selectedPipelineId
    };

    setBtnLoading(true);
    let otpResp = await VerifyOTP(structure);
    setBtnLoading(false);

    if (otpResp.error == true) {
      return;
    }

    setOpenResetPasswordPop(true);
  };

  const [resendLoading, setResendLoading] = useState(false);

  const handleResendClick = async () => {
    if (!isResendDisabled) {
      setIsResendDisabled(true);
      setTimer(60); // Reset timer to 60 seconds
      setResendLoading(true);

      let request = {};
      request[credentialType] = credential;

      await sendOtp(
        request,
        credentialType == "email" ? "/resend-otp/email" : "/resend-otp/phone"
      );

      setResendLoading(false);
      // Countdown function
      const countdown = setInterval(() => {
        setTimer((prevTime) => {
          if (prevTime === 1) {
            clearInterval(countdown);
            setIsResendDisabled(false); // Enable after 60 seconds
          }
          return prevTime - 1;
        });
      }, 1000);
    }
  };

  const validateInputField = (type, value) => {
    if (!value) {
      setTextError("*Required");
      return false;
    } else {
      if (value.length < 6) {
        setTextError(`${type} Must be of 6 Characters`);
        return false;
      } else {
        setTextError("");
        return true;
      }
    }
  };

  let validateInput = () => {
    validateInputField("OTP", inputText);
  };

  return openResetPasswordPop == false ? (
    <div className="register-login">
      <div
        className="back-text proxima_semibold color_endeavour font12"
        onClick={() => setOpenResetPassword(false)}
      >
        BACK
      </div>

      <div className="header">
        <img
          src={images["user-login-icon.svg"]}
          alt=""
          className="login-icon"
        />
        <div className="title proxima_semibold color_black font22">
          Reset Password
        </div>
      </div>

      <div className="otp proxima_semibold color_black font12">
        Verify OTP sent to {credentialType.toUpperCase()} : {credential}
      </div>

      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!textError}
          helperText={textError}
          value={inputText}
          onChange={onChangeInput}
          onBlur={validateInput}
          id="outlined-basic"
          label={"Enter OTP"}
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div
                  className={`resend-otp proxima_semibold font13 ${
                    isResendDisabled ? "disabled" : "color_endeavour"
                  }`}
                  onClick={handleResendClick}
                  style={{
                    cursor: isResendDisabled ? "not-allowed" : "pointer",
                    color: isResendDisabled ? "#B0B0B0" : "#0057B7",
                    textDecorationColor: isResendDisabled
                      ? "#B0B0B0"
                      : "#0057B7",
                  }}
                >
                  {resendLoading ? (
                    <CircularProgress size={18} sx={{ color: "#0057B7" }} />
                  ) : (
                    "Resend OTP"
                  )}
                </div>
              </InputAdornment>
            ),
          }}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!inputText}
        sx={{
          width: "100%",
          backgroundColor: "#0057B7",
          color: "#fff",
          fontSize: "16px",
          fontFamily: `var(--font-family-proxima_nova-regular)`,
          fontWeight: "600",
          marginTop: "10px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0045A5" },
          "&:disabled": {
            backgroundColor: "#B0B0B0",
            color: "#fff",
            cursor: "not-allowed",
          },
        }}
      >
        {" "}
        {btnLoading ? (
          <CircularProgress size={24} sx={{ color: "white" }} />
        ) : (
          "VERIFY"
        )}
      </Button>

      <div className="tandc color_light-gray-black font14 proxima_regular">
        By proceeding, you agree to TripPrizer's{" "}
        <span className="color_endeavour">Privacy Policy, User Agreement</span>{" "}
        and <span className="color_endeavour">T&Cs</span>
      </div>
    </div>
  ) : (
    <ResetPassword
      setOpenResetPassword={setOpenResetPassword}
      setOpenResetPasswordPop={setOpenResetPasswordPop}
      credential={credential}
      credentialType={credentialType}
    />
  );
}

export default ResetPasswordVerify;
